import React from 'react'
import About from './components/about'
import Header from './components/Header'
import Footer from './components/footer'

const AboutUs = () => {
  return (
    <div>
        <Header />
        <div 
        // style={{ backgroundColor: '#9EDEFF' }}
        >
        <h1 className='ms-5 pt-3 text-center' > <b> <i>  About Us </i></b> </h1>
        {/* <h4> Send us a message and we will get back to your through your mail/phone. </h4>  */}
        <About />
        </div>
        <Footer />
    </div>


  )
}

export default AboutUs